export const ALERT_CONTENT = {
  REQUIRED_DATA_ERROR: {
    variant: 'error',
    message:
      'Error loading required data for signing. Our team has been notified and working on a fix.',
  },
  ENABLED_SUCCESS: {
    variant: 'success',
    message: 'One-Click Trading Enabled',
  },
  ENABLE_ERROR: {
    variant: 'error',
    getMessage: (error: Error) => error.message,
  },
  REVOKE_ERROR: {
    variant: 'error',
    getMessage: (error: Error) => error.message,
  },
  RENEW_ERROR: {
    variant: 'error',
    getMessage: (error: Error) => error.message,
  },
  ENABLE_PENDING: {
    variant: 'info',
    message: 'Enabling One-Click Trading can take up to 15 seconds',
  },
  REVOKE_PENDING: {
    variant: 'info',
    message: 'Disabling One-Click Trading can take up to 15 seconds',
  },
  RENEW_PENDING: {
    variant: 'info',
    message: 'Renewal of One-Click Trading can take up to 15 seconds',
  },
  HAS_OPEN_ORDERS: {
    variant: 'warning',
    getMessage: (orderCount: number) =>
      `Disabling One-Click Trading requires closing ${orderCount} open order${orderCount > 1 ? 's' : ''} linked to this browser.`,
  },
} as const;
